const Types = {
  SL_COUNTRY_CODE: "+94",
  NATIONALITY: "SRI LANKAN",
  ID_FN_TYPE: "NIC",
  PERMANENT_ADDRESS: 1,
  CORRESPONDENCE_ADDRESS: 2,
  EMPLOYER_ADDRESS: 4,
  FILL_DATA: "FILL_DATA",
  PROVINCE: "Province",
  COUNTRY: "Country",
  BANK: "Bank",
  API_SUCCESS_CODE: "000",
  API_FAILED_CODE: "001",
  PERSON_ID_PRIMARY_CUSTOMER: "1",
  PERSON_ID_SUPPLEMENTARY: "2",
  PRIMARY_CUSTOMER: 1,
  JOINT_CUSTOMER: 2,
  SUPPLEMENTARY_CUSTOMER: 3,
  MASTER: "MASTER",
  AMEX: "AMEX",
  IS_RESIDENT_Y: "Y",
  DARAZ_PREPAID_CARD: "1538",
};
export default Types;
